module.exports = __webpack_public_path__ + "assets/img/word.1ef952ec.png";